// extracted by mini-css-extract-plugin
export default {"step":"StepCSS_step__eXhtA","title":"StepCSS_title__-U0RN","text":"StepCSS_text__NSk-V"};